<template>
  <div v-if="show" class="sidebar-links">
    <router-link v-if="isAdmin" to="/clinical">All Studies</router-link>
    <router-link v-if="isSurgeon" :to="surgeonProfileRoute">My Study Profile</router-link>
    <rp-permissions :requireAll="['write_trials']">
      <router-link to="/clinical/add-study">Add New Study</router-link>
    </rp-permissions>
    <rp-permissions :requireAll="['manage_trials']">
      <router-link to="/clinical/search-surgeon">Search Surgeon</router-link>
    </rp-permissions>

  </div>
</template>

<script>
import Permissions from 'raypro_ui/src/components/Permissions'
import {mapGetters} from 'vuex'

export default {
  components: {
    'rp-permissions': Permissions,
  },

  computed: {
    ...mapGetters(['authUser', 'isSurgeon', 'isAdmin']),

    path() {
      return this.$route.path
    },

    show() {
      return new RegExp('/clinical').test(this.path)
    },

    surgeonProfileRoute() {
      return {name: 'view-surgeon-trials', params: {id: this.authUser.id}}
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/SideNav/ClinicalLinks.vue